import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/modules/user";
import customer from "@/store/modules/CustomerModule";
import firebase from "@/store/modules/FirebaseModule";
import steps from "@/store/modules/StepsModule";
import gtm from "@/store/modules/GtmModule";
import idOrigin from "@/store/modules/IdOriginModule";
import validations from "@/store/modules/ValidationsModule";
import coupon from "@/store/modules/CouponModule";
import simDelivery from "@/store/modules/SimDeliveryModule";
import acquisition from "@/store/modules/AcquisitionModule";
import chat from "@/store/modules/ChatModule";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    firebase,
    customer,
    steps,
    gtm,
    idOrigin,
    validations,
    coupon,
    simDelivery,
    acquisition,
    chat,
  },
});

const storeActions = {
  ...user.actions,
  ...firebase.actions,
  ...customer.actions,
  ...steps.actions,
  ...gtm.actions,
  ...idOrigin.actions,
  ...validations.actions,
  ...coupon.actions,
  ...simDelivery.actions,
  ...acquisition.actions,
  ...chat.actions,
};

export { storeActions };
